// array
require('core-js/fn/array/find');
require('core-js/fn/array/includes');

// string
require('core-js/fn/string/includes');


// object
require('core-js/fn/object/entries');
require('core-js/fn/object/values');
require('core-js/fn/object/assign');





//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-webpack-config/polyfills.js
// module id = ../node_modules/xo-webpack-config/polyfills.js
// module chunks = 0